
namespace RioERP.Reports {

    @Serenity.Decorators.registerClass()
    export class B2CDialog extends Serenity.EntityDialog<B2CRow, any> {
        protected getFormKey() { return B2CForm.formKey; }
        protected getIdProperty() { return B2CRow.idProperty; }
        protected getLocalTextPrefix() { return B2CRow.localTextPrefix; }
        protected getNameProperty() { return B2CRow.nameProperty; }
        protected getService() { return B2CService.baseUrl; }
        protected getDeletePermission() { return B2CRow.deletePermission; }
        protected getInsertPermission() { return B2CRow.insertPermission; }
        protected getUpdatePermission() { return B2CRow.updatePermission; }

        protected form = new B2CForm(this.idPrefix);

    }
}